import PropTypes from 'prop-types';
import { Select } from 'antd';
import * as React from 'react';
import stylePropType from 'react-style-proptype';
import { injectIntl } from 'react-intl';
import { AttributeTypes } from './Attributes';
import config from '../../../config';

const SelectOption = Select.Option;
const isCustomBranches = config['app.system.branch_type'] === 'CUSTOM';
const skipTypes = [
  isCustomBranches ? AttributeTypes.classification_code : AttributeTypes.branch,
];

class LeadScoringAttributeTypeSelector extends React.Component {
  constructor(props) {
    super(props);

    const types = [
      {
        id: AttributeTypes.lead_label,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.lead_label' }),
      },
      {
        id: AttributeTypes.company_pattern,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.company_pattern' }),
      },
      {
        id: AttributeTypes.branch,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.branch' }),
      },
      {
        id: AttributeTypes.classification_code,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.classification_code' }),
      },
      {
        id: AttributeTypes.company_size,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.company_size' }),
      },
      {
        id: AttributeTypes.country,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.country' }),
      },
      {
        id: AttributeTypes.campaign,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.campaign' }),
      },
      {
        id: AttributeTypes.zip_code,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.zip_code' }),
      },
      {
        id: AttributeTypes.duration,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.duration' }),
      },
      {
        id: AttributeTypes.returned_visitor,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.returned_visitor' }),
      },
      {
        id: AttributeTypes.source,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.source' }),
      },
      {
        id: AttributeTypes.referrer,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.referrer' }),
      },
      {
        id: AttributeTypes.page_group,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.page_group' }),
      },
      {
        id: AttributeTypes.country_group,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.country_group' }),
      },
      {
        id: AttributeTypes.file_download,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.file_download' }),
      },
      {
        id: AttributeTypes.email_click,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.email_click' }),
      },
      {
        id: AttributeTypes.phone_click,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.phone_click' }),
      },
      {
        id: AttributeTypes.form_submit,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.form_submit' }),
      },
      {
        id: AttributeTypes.isp,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.isp' }),
      },
      {
        id: AttributeTypes.hidden,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.hidden' }),
      },
    ];

    const visibleTypes = types.filter((i) => {
      return skipTypes.indexOf(i.id) === -1;
    });


    this.state = {
      options: visibleTypes,
      value: this.props.value,
    };
  }

  handleChange = (value) => {
    const object = this.state.options.find(i => i.id === value);
    this.props.onChange(object);
  }

  render() {
    return (
      <Select onChange={this.handleChange} style={this.props.style} name={this.props.name} value={this.props.value}>
        {this.state.options.map((option, index) =>
          (<SelectOption key={index} value={option.id}>
            {option.label}
          </SelectOption>),
        )}
      </Select>
    );
  }
}

LeadScoringAttributeTypeSelector.propTypes = {
  style: stylePropType,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default injectIntl(LeadScoringAttributeTypeSelector);



// WEBPACK FOOTER //
// ./src/components/LeadScoring/LeadScoringAttributeTypeSelector/LeadScoringAttributeTypeSelector.js